import { IOpoContactPosition } from './opo-contact';

export interface IOpoPortalUser {
    id: number,
    firstName: string,
    lastName: string,
    email: string,
    username: string,
    groupId: number,
    groupName: string,
    isDeactivated: boolean,
    isManageable: boolean,
    isPendingVerification: boolean,
    isVerificationExpired: boolean,
    verificationExpiresDate: string | null,
    contactPositions: number[]
}

export interface IOpoPortalUsersData {
    users: IOpoPortalUser[],
    positions: IOpoContactPosition[],
    canManage: boolean,
    currentUserId: number
}

export interface IOpoUserAddRequest {
    email: string,
    username: string,
    firstName: string,
    lastName: string,
    groupId: number,
    contactPositions: number[]
}

export interface IOpoUserUpdateRequest {
    firstName: string,
    lastName: string,
    username: string,
    groupId: number,
    contactPositions: number[],
    password: string,
    requirePasswordChange: boolean
}
